<mat-form-field appearance="outline"
                class="w-100 bg-white"
                [subscriptSizing]="'dynamic'">
    <input matInput
           [(ngModel)]="searchTerm"
           (ngModelChange)="onSearchTermChange()"
           [placeholder]="placeholder">
    <mat-icon matPrefix>search</mat-icon>
</mat-form-field>